import ICON from '@watchface/pages/DesignTool/components/IconComponent/config'

export const DEFAULT_EDITABLE_ASSETS = {
  selectState: 'select',
  defaultShow: '',
  value: '',
}

export const DEFAULT_EDITABLE_MASK_ASSETS = {
  showCover: 1,
  showMask: 1
}


const DEFAULT_COMPONENT_RECTANGLE = {
  position: {
    x: 184,
    y: 102
  },
  width: 113,
  height: 80
}

export const createDefaultEditableComponentData = (component) => ({
  ...component,
  rectangle: DEFAULT_COMPONENT_RECTANGLE,
  select_image: '',
  unselect_image: '',
  text_tag: {
    position: {
      x: 199,
      y: 63
    },
    image: '',
    width: 89,
    height: 36
  },
  text_display_width: 89,
  text_margin: 10,
  select_list: {
    title_font_size: 34,
    title_align_h: 'center',
    list_item_vspace: 8,
    list_tips_text_font_size: 32,
    list_tips_text_align_h: 'left'
  }
})

export const createDefaultEditableMaskData = () => ({
  cover: '',
  mask: ''
})

const EDITABLE = {
  rectangle: {
    position: {
      x: 0,
      y: 0
    },
    width: 0,
    height: 0
  },
  select_image: '',
  unselect_image: '',
  text_tag: ICON,
  text_display_width: 0,
  text_margin: 0,
  select_list: {
    title_font_size: 34,
    title_align_h: 'center',
    list_item_vspace: 8,
    list_tips_text_font_size: 32,
    list_tips_text_align_h: 'left'
  },
  props: {}
}
export default EDITABLE
